module.exports = {
      id: "health-usage",
      viewBox: "0 0 26.46 26.46",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#health",
      toString: function () {
        return this.url;
      }
    }